module.exports = __webpack_public_path__ + "img/AndroidTV_X7500F.8768f5cf.png";